// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"601":"883e7151","616":"0016b86a"}[chunkId] + ".chunk.js";
};